import React from 'react';
import { Calendar, Edit2, Trash2, Megaphone } from 'lucide-react';

function AnnouncementList({ announcements = [], onEdit, onDelete }) {
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('tr-TR', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  if (announcements.length === 0) {
    return (
      <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-8 text-center">
        <Megaphone className="w-10 h-10 text-zinc-700 mx-auto mb-3" />
        <p className="text-zinc-500 text-sm">Henüz duyuru yok</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
      {announcements.map((announcement) => (
        <div key={announcement.id} className="bg-zinc-900 border border-zinc-800 rounded-lg overflow-hidden hover:border-zinc-700 transition-colors group">
          <div className="flex">
            <div className="w-24 h-24 flex-shrink-0 bg-zinc-800">
              <img src={announcement.cardImage || '/images/placeholder.jpg'} alt={announcement.title} className="w-full h-full object-cover"
                onError={(e) => { e.target.onerror = null; e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="100" height="100"%3E%3Crect fill="%2327272a" width="100" height="100"/%3E%3C/svg%3E'; }} />
            </div>
            <div className="flex-1 p-3 min-w-0">
              <h3 className="text-white text-sm font-medium line-clamp-1 mb-1">{announcement.title}</h3>
              <p className="text-zinc-500 text-xs flex items-center gap-1 mb-1">
                <Calendar className="w-3 h-3" /> {formatDate(announcement.date)}
              </p>
              <p className="text-zinc-400 text-xs line-clamp-2">{announcement.shortDetail}</p>
            </div>
          </div>
          <div className="flex border-t border-zinc-800">
            <button onClick={() => onEdit(announcement)} className="flex-1 flex items-center justify-center gap-1.5 py-2 text-zinc-400 hover:text-violet-400 hover:bg-violet-500/10 text-xs transition-colors">
              <Edit2 className="w-3 h-3" /> Düzenle
            </button>
            <button onClick={() => onDelete(announcement.id)} className="flex-1 flex items-center justify-center gap-1.5 py-2 text-zinc-400 hover:text-red-400 hover:bg-red-500/10 text-xs transition-colors border-l border-zinc-800">
              <Trash2 className="w-3 h-3" /> Sil
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}

export default AnnouncementList;
